/**
 * Data hook for the Operations stat-card summary row.
 *
 *   useOperationsSummary() — polls GET /api/operations/summary every 30s.
 *   Returns per-phase counts of the 7 lifecycle books.
 *
 * Why 30s, not 15s like the books: the summary fans out to 7 Airtable
 * count queries on each *uncached* miss. The endpoint reuses the
 * AirtableClient's default 60s KV cache (counts tolerate that
 * staleness; see PlacementReader.countByDecision), so most polls
 * resolve from cache anyway — but pulling the poll back to 30s keeps
 * the worst case under the 60s cache window without churning the
 * row visibly. The row is a glance, not a watch surface.
 *
 * Spec: docs/port-survey/reconciliation.md (evicted 2026-08-29, #775 round 10) (D2 — stat-card row),
 *       packages/shared/src/operations-summary.ts.
 */

import { OperationsSummaryResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useOperationsSummary = createPollingQuery({
  queryKey: ["operations-summary"] as const,
  path: "/api/operations/summary",
  schema: OperationsSummaryResponseSchema,
  refetchIntervalMs: 30_000,
});
